import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "native-base";
import { invariant } from "@madmedical/utils";
import { useTranslation } from "@madmedical/i18n";
import { useRouteNavigate } from "../../providers/routing";
import Headline from "../../molecules/Headline";
import Breadcrumb from "../../molecules/Breadcrumb";
import Tabs from "../../molecules/Tabs";
import { useInsulinReminder } from "../../providers/insulinReminder";
import Button from "../../atoms/Button";
import InsulinReminderList from "./InsulinReminderList";
const InsulinReminderContent = ({ isPatient, deleteReminder, editReminder, }) => {
    const { reminders } = useInsulinReminder();
    const { t } = useTranslation();
    const navigate = useRouteNavigate();
    invariant(reminders);
    const reminderData = reminders === null || reminders === void 0 ? void 0 : reminders.map((item) => (Object.assign(Object.assign({}, item), { editable: isPatient })));
    return (_jsxs(Box, Object.assign({ width: "full" }, { children: [_jsx(Headline, { minHeight: 12, px: 6, borderBottomWidth: 1, borderBottomColor: "gray.100", borderBottomStyle: "solid", leftContent: _jsx(Breadcrumb, { children: _jsx(Breadcrumb.Item, { children: _jsx(Breadcrumb.Text, { children: t("reminders") }) }) }), rightContent: _jsx(Button, Object.assign({ variant: "outlined", leftIconName: "add", onPress: () => {
                        navigate("insulin", {});
                    } }, { children: "\u00DAj eml\u00E9keztet\u0151" })) }), _jsx(Box, Object.assign({ backgroundColor: "white", borderColor: "gray.100", borderBottomWidth: 1, flexDirection: "row" }, { children: _jsx(Tabs, { tabs: [
                        {
                            title: t("insulin"),
                            content: (_jsx(InsulinReminderList, { data: reminderData, onEndReached: () => console.log("end"), onDeletePress: deleteReminder, onEditPress: editReminder })),
                        },
                    ], px: 4, borderBottomColor: "gray.100", borderBottomWidth: 1 }) }))] })));
};
export default InsulinReminderContent;
